/* ===========================================================================
   DRINEA — Builder de pack (Duo / Trio), vanilla pur.
   Chaque "slot" = un legging : choix Couleur + Taille → variante réelle.
   "Ajouter" pose N lignes au panier via /cart/add.js avec les propriétés
   internes _drinea_bundle_type / _drinea_bundle_id / _drinea_bundle_slot.

   Correctif 2026-09-02 :
   - confirmation visible dès que Shopify accepte l'ajout ;
   - compteur du header synchronisé depuis /cart.js ;
   - ouverture du cart drawer si disponible ;
   - repli vers /cart si le drawer global n'est pas disponible.
   =========================================================================== */
(function () {
  'use strict';

  var root = document.querySelector('[data-bundle]');
  var dataEl = document.querySelector('[data-bundle-variants]');
  if (!root || !dataEl) return;

  var variants = [];
  try { variants = JSON.parse(dataEl.textContent || '[]'); } catch (e) { variants = []; }
  if (!variants.length) return;

  var bundleType = root.getAttribute('data-bundle-type') || 'duo';
  var slotCount = parseInt(root.getAttribute('data-bundle-count'), 10) || 2;
  var colourPos = parseInt(root.getAttribute('data-colour-pos'), 10) || 1;
  var sizePos = parseInt(root.getAttribute('data-size-pos'), 10) || 2;

  var addBtn = document.querySelector('[data-bundle-add]');
  var msgEl = document.querySelector('[data-bundle-msg]');

  function norm(v) { return (v == null ? '' : String(v)).trim().toLowerCase(); }

  function findVariant(colour, size) {
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      var opts = v.options || [];
      if (norm(opts[colourPos - 1]) === norm(colour) && norm(opts[sizePos - 1]) === norm(size)) return v;
    }
    return null;
  }

  var slots = [];
  var slotEls = root.querySelectorAll('[data-bb-slot]');

  slotEls.forEach(function (slotEl) {
    var state = { colour: null, size: null, variant: null, el: slotEl };
    slots.push(state);

    var summary = slotEl.querySelector('[data-bb-summary]');
    var colorName = slotEl.querySelector('[data-bb-colorname]');
    var img = slotEl.querySelector('[data-bb-img]');

    function refreshSlot() {
      state.variant = (state.colour && state.size) ? findVariant(state.colour, state.size) : null;
      if (summary && state.colour && state.size) {
        summary.textContent = state.colour + ' · ' + state.size + (state.variant && !state.variant.available ? ' (indispo)' : '');
        summary.classList.add('on');
      }
      updateAddState();
    }

    slotEl.querySelectorAll('[data-bb-color]').forEach(function (sw) {
      sw.addEventListener('click', function () {
        slotEl.querySelectorAll('[data-bb-color]').forEach(function (s) { s.classList.remove('on'); });
        sw.classList.add('on');
        state.colour = sw.getAttribute('data-bb-color');
        if (colorName) colorName.textContent = state.colour;
        var im = sw.getAttribute('data-bb-img');
        if (img && im) img.src = im;
        refreshSlot();
      });
    });

    slotEl.querySelectorAll('[data-bb-size]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        slotEl.querySelectorAll('[data-bb-size]').forEach(function (b) { b.classList.remove('on'); });
        btn.classList.add('on');
        state.size = btn.getAttribute('data-bb-size');
        refreshSlot();
      });
    });
  });

  function allReady() {
    if (slots.length < slotCount) return false;
    for (var i = 0; i < slots.length; i++) {
      if (!slots[i].variant || !slots[i].variant.available) return false;
    }
    return true;
  }

  function updateAddState() {
    if (!addBtn) return;
    addBtn.disabled = !allReady();
  }

  function updateCartCount(count) {
    document.querySelectorAll('.cart-count').forEach(function (el) {
      el.textContent = String(count);
    });
  }

  function bundleId() {
    return bundleType + '-' + Date.now().toString(36) + Math.floor(Math.random() * 1e6).toString(36);
  }

  function setMsg(t, isErr) {
    if (!msgEl) return;
    msgEl.textContent = t || '';
    msgEl.classList.toggle('err', !!isErr);
  }

  function openConfirmedCart() {
    if (window.DrineaCart && typeof window.DrineaCart.open === 'function') {
      return Promise.resolve(window.DrineaCart.open()).catch(function () {
        window.location.assign('/cart');
      });
    }
    window.location.assign('/cart');
    return Promise.resolve();
  }

  function syncCartAndOpen() {
    return fetch('/cart.js', {
      headers: { 'Accept': 'application/json' },
      credentials: 'same-origin'
    })
      .then(function (r) {
        if (!r.ok) throw new Error('Cart refresh failed');
        return r.json();
      })
      .then(function (cart) {
        updateCartCount(cart.item_count || 0);
        return openConfirmedCart();
      })
      .catch(function () {
        return openConfirmedCart();
      });
  }

  if (addBtn) {
    addBtn.addEventListener('click', function () {
      if (!allReady()) {
        setMsg('Choisissez couleur et taille pour chaque legging.', true);
        return;
      }

      var id = bundleId();
      var items = slots.map(function (s, i) {
        return {
          id: s.variant.id,
          quantity: 1,
          properties: {
            _drinea_bundle_type: bundleType,
            _drinea_bundle_id: id,
            _drinea_bundle_slot: String(i + 1)
          }
        };
      });

      addBtn.disabled = true;
      addBtn.setAttribute('aria-busy', 'true');
      setMsg('Ajout en cours…', false);

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items }),
        credentials: 'same-origin'
      })
        .then(function (r) {
          if (!r.ok) return r.json().then(function (e) { throw e; });
          return r.json();
        })
        .then(function (added) {
          setMsg('Pack ajouté ✓ Ouverture de votre panier…', false);

          if (window.DrineaPixel && window.DrineaPixel.trackAddToCart) {
            var addedItems = (added && added.items) ? added.items : [];
            var value = addedItems.reduce(function (sum, item) {
              var cents = item.final_line_price || (item.final_price || item.price || 0) * (item.quantity || 1);
              return sum + (Number(cents) || 0);
            }, 0) / 100;
            window.DrineaPixel.trackAddToCart({
              content_ids: items.map(function (item) { return String(item.id); }),
              content_type: 'product',
              num_items: items.length,
              value: value || undefined
            });
          }

          return syncCartAndOpen();
        })
        .catch(function (err) {
          var m = (err && err.description) ? err.description : 'Ajout impossible. Réessayez.';
          setMsg(m, true);
        })
        .then(function () {
          addBtn.removeAttribute('aria-busy');
          updateAddState();
        });
    });
  }

  updateAddState();
})();
